import { Path, Props, Wrapper, buildPath } from "./Overlay.Parts";

export const Overlay = ({ overlay }: Props) => (
  <Wrapper viewBox={`0 0 ${overlay.length - 1} 1`} preserveAspectRatio="none">
    <Path d={buildPath(overlay)} />
  </Wrapper>
);
